import {
  TextField,
  Grid,
  Typography,
  Box,
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  IconButton,
  Autocomplete,
} from "@mui/material";
import { useState, useMemo, useContext, useEffect } from "react";
import { useInvoice } from "../../stores/useInvoice";
import { Filters } from "../../models/Filters";
import { LanguageContext } from "../../globals/LanguageContext";
import { ArrowDown, ArrowUp } from "@phosphor-icons/react";

type DescriptionFilterProps = {
  filters: Filters;
  onChange: (val: any) => void;
};

export function DescriptionFilter({
  filters,
  onChange,
}: DescriptionFilterProps) {
  const { invoices } = useInvoice();
  const { dictionary } = useContext(LanguageContext);
  const availableDescriptions = useMemo(() => {
    if (!invoices) return [];
    const allDescriptions = invoices.map((inv) => inv.description);
    return Array.from(new Set(allDescriptions)).sort();
  }, [invoices]);

  const toggleSortDirection = () => {
    const current = filters.sortDirection?.direction || "asc";
    onChange({
      ...filters,
      sortDirection: {
        key: "description",
        direction: current === "asc" ? "desc" : "asc",
      },
    });
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle1" sx={{ mr: 1 }}>
            {dictionary.filters.description}
          </Typography>
          <IconButton onClick={toggleSortDirection} size="small">
            {filters.sortDirection?.direction === "desc" ? (
              <ArrowDown fontSize="small" />
            ) : (
              <ArrowUp fontSize="small" />
            )}
          </IconButton>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Autocomplete
          options={availableDescriptions}
          value={filters.selectedDescription || ""}
          onChange={(_, newValue) =>
            onChange({ ...filters, selectedDescription: newValue || "" })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Search description"
              placeholder="Select description"
              fullWidth
            />
          )}
          clearOnEscape
          freeSolo
        />
      </Grid>
    </Grid>
  );
}
